import type { FC } from "react";

import dompurify from "isomorphic-dompurify";

import { Card } from "@jti/core-components/components/Card";

export type HeaderBlockProps = {
  header: string;
  text: string;
  componentId?: string;
};

const { sanitize } = dompurify;

export const HeaderBlock: FC<HeaderBlockProps> = ({ header, text, componentId }) => {
  return (
    <Card title={header} id={componentId}>
      <div dangerouslySetInnerHTML={{ __html: sanitize(text) }} />
    </Card>
  );
};
